import { Button } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content, Header } from 'antd/es/layout/layout';
import styled from 'styled-components';

export const DashboardTemplateContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledSider = styled(Sider)`
    min-height: 100vh;
    max-height: 100vh;
    z-index: 10 !important;
    overflow-y: auto;
`;

export const StyledHeader = styled(Header)`
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & svg {
        color: white;
    }
`;

interface ILogoContainer {
	imageurl: string;
}

export const LogoContainer = styled.div<ILogoContainer>`
    min-height: 64px;
    height: 80px;
    padding: 8px;
    margin-bottom: 15px;
    background-image: ${({ imageurl, }) => `url('${imageurl}')`};
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

export const MainContent = styled(Content)`
    padding: 15px;
    display: flex;
    flex-direction: column;
    background-color: #f0f2f5;
    max-height: calc(100vh - 64px);
    overflow: auto;
    position: relative;

    @media (max-width: 768px) {
        min-height: calc(100vh - 64px);
    }
`;

export const StyledContent = styled(Content)`
    background-color: #fafafa;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 5px 8px 24px 5px rgba(208, 216, 243, 0.4);
    height: fit-content;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const MobileCloseSiderTrigger = styled(Button)``;
